import { useDispatch, useSelector } from "react-redux";
import {
  AnalyticsTypeMap,
  FAVOURITES_VIEW,
  MARKETS_VIEW,
  ODDS_VIEW,
} from "../constants";
import {
  sendAnalyticsEvent,
  generateFavouriteAnalyticsType,
} from "../lib/postMessage";
import {
  CLEAR,
  CLOSE,
  FAVOURITES,
  FILTERS,
  SHOW,
} from "../constants/analytics";

export const useFilterActions = ({
  activeFilterView,
  emptyFilters,
  marketSelectionsCount,
}) => {
  const dispatch = useDispatch();
  const { prefetchedFilters, storedFavourites } = useSelector(
    (state) => state.filter
  );

  const handleShowAllSelections = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    dispatch({
      type: "SET_ACTIVE_FILTER_VIEW",
      payload: "",
    });

    const isFavouritesView = activeFilterView === FAVOURITES_VIEW;

    if (isFavouritesView) {
      sendAnalyticsEvent({
        event: FAVOURITES,
        type: generateFavouriteAnalyticsType(prefetchedFilters.favourites),
        action: SHOW,
      });
    } else {
      sendAnalyticsEvent({
        event: FILTERS,
        type: AnalyticsTypeMap.get(activeFilterView) ?? activeFilterView,
        action: SHOW,
      });
    }

    if (emptyFilters) {
      localStorage.removeItem("selectionCount");
    } else {
      localStorage.setItem("selectionCount", marketSelectionsCount.count);
    }

    dispatch({
      type: "FINALISE_FILTER_SELECTIONS",
    });
  };

  const closeFilter = () => {
    window.scrollTo(0, 0);
    dispatch({
      type: "SET_ACTIVE_FILTER_VIEW",
      payload: "",
    });

    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get(activeFilterView) ?? activeFilterView,
      action: CLOSE,
    });

    dispatch({
      type: "RESET_PREFETCHED_FILTERS",
    });
  };

  const clearAllSelections = () => {
    const isFavouritesView = activeFilterView === FAVOURITES_VIEW;

    if (isFavouritesView) {
      dispatch({
        type: "RESET_FAVOURITE_SELECTIONS",
      });
      return;
    }

    if (activeFilterView === ODDS_VIEW || activeFilterView === MARKETS_VIEW) {
      const favourite = storedFavourites.find(
        (favourite) => favourite.type === activeFilterView
      );
      if (favourite) {
        dispatch({
          type: "REMOVE_FAVOURITE_SELECTIONS",
          payload: {
            id: favourite.id,
          },
        });
      }
    }

    if (activeFilterView === ODDS_VIEW) {
      dispatch({
        type: "REMOVE_FROM_ODDS_SELECTIONS",
        payload: {
          filter: activeFilterView,
        },
      });
    } else {
      dispatch({
        type: "RESET_FILTER_SELECTIONS",
        payload: {
          type: activeFilterView,
        },
      });
    }

    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get(activeFilterView) ?? activeFilterView,
      action: CLEAR,
    });

    dispatch({
      type: "RESET_FILTERS",
    });
  };

  return {
    handleShowAllSelections,
    closeFilter,
    clearAllSelections,
  };
};
